module.exports = __webpack_public_path__ + "img/btn24.6f5399d2.png";